import clsx from 'clsx'
import { type ReactElement, type TextareaHTMLAttributes } from 'react'
import { Check, WarningCircle } from 'phosphor-react'

type InputProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label?: string
  isValid: boolean
  errorMessage?: string
  isHighlighted?: boolean
  isDisabledAttrStyled?: boolean
  renderEndAdornment?: () => ReactElement
}

export const Textarea = ({
  label,
  isValid,
  errorMessage,
  isHighlighted,
  isDisabledAttrStyled = true,
  renderEndAdornment,
  ...props
}: InputProps) => {
  return (
    <label>
      {label && (
        <span className="block mb-1 text-xs lg:text-sm text-grey-800 lg:mb-1">
          {label}
        </span>
      )}

      <div className="relative">
        <textarea
          {...props}
          className={clsx(
            'resize-none h-[150px] p-3 pr-10 lg:pr-12 w-full rounded-lg outline-none border-grey-500 border-1 font-normal text-xs text-grey-800 placeholder:text-grey-500 placeholder:font-sans lg:py-4 lg:text-sm',
            {
              'disabled:bg-grey-300 disabled:text-grey-500':
                isDisabledAttrStyled,
              'border-red-500': errorMessage,
              'focus:border-grey-700': !errorMessage,
              'border-grey-900 focus:border-grey-900': isHighlighted,
            }
          )}
        />

        <div className="absolute flex top-1/2 right-4 -translate-y-2/4">
          {typeof renderEndAdornment === 'function' ? (
            renderEndAdornment()
          ) : (
            <>
              {errorMessage && (
                <WarningCircle className="text-lg lg:text-2xl text-[#FF4949]" />
              )}
              {!errorMessage && isValid && (
                <Check className="text-lg lg:text-2xl text-[#08B919]" />
              )}
            </>
          )}
        </div>
      </div>

      {errorMessage && (
        <p className="mt-2 text-[#FF4949] text-xs">{errorMessage}</p>
      )}
    </label>
  )
}
